module.exports = __webpack_public_path__ + "static/img/xiamen.98a955c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/xiamen.jpg
// module id = woZ0
// module chunks = 1